import { render } from "./viewrebus.vue?vue&type=template&id=6406bbb1&scoped=true"
import script from "./viewrebus.vue?vue&type=script&lang=js"
export * from "./viewrebus.vue?vue&type=script&lang=js"

import "./viewrebus.vue?vue&type=style&index=0&id=6406bbb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6406bbb1"]])

export default __exports__